import { BrandKitStepProps } from 'components/FirstTimeExperienceModal/Types'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import React from 'react'
import { BrandVoice as MobileBrandVoice } from 'screens/BrandKit/MobileBrandKit/BrandVoice'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { BrandVoice } from 'screens/BrandKit/BrandVoice/BrandVoice'
export const BrandKitVoice: React.FC<BrandKitStepProps & { title?: string }> = ({
  onNext,
  onBack,
  onSkip,
  brandKit,
  title,
}) => {
  return (
    <MultiStepStepLayout
      title={title}
      description="We used your website to to understand how you talk to your customers.."
      onBack={onBack}
      onNext={onNext}
      onSkip={onSkip}
      nextButtonText="Save Brand Kit"
    >
      <ResponsiveDesign.Desktop>
        <BrandVoice brandKit={brandKit} />
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <MobileBrandVoice brandKit={brandKit} />
      </ResponsiveDesign.Mobile>
    </MultiStepStepLayout>
  )
}
